
export type GetProfileByUsername200PreferencesTheme = typeof GetProfileByUsername200PreferencesTheme[keyof typeof GetProfileByUsername200PreferencesTheme];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProfileByUsername200PreferencesTheme = {
  light: 'light',
  dark: 'dark',
  auto: 'auto',
} as const;
